import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useMemo } from 'react'
import { buildXeroAccountOptions } from 'Products/utils/buildXeroAccountOptions'
import { useShouldShowXeroMappings } from 'Products/hooks/useShouldShowXeroMappings'

export const useXeroLedgerAccountOptions = () => {
  const shouldShow = useShouldShowXeroMappings()

  const mappingsQuery = useQuery(
    dashboardv99990101Client.getXeroLedgerAccountMappings,
    undefined,
    {
      enabled: shouldShow
    }
  )

  const mappings = mappingsQuery.data?.items ?? []

  const accounts = useMemo(
    () => ({
      deferred: buildXeroAccountOptions(mappings, 'DEFERRED_REVENUE'),
      recognized: buildXeroAccountOptions(mappings, 'RECOGNIZED_REVENUE'),
      unbilled: buildXeroAccountOptions(mappings, 'UNBILLED_REVENUE')
    }),
    [mappings]
  )

  const hasMappings = Object.values(accounts).some(account => account.count > 0)

  return {
    isLoading: shouldShow && mappingsQuery.isLoading,
    hasError: shouldShow && Boolean(mappingsQuery.error),
    hasMappings,
    deferredRevenueOptions: accounts.deferred.options,
    recognizedRevenueOptions: accounts.recognized.options,
    unbilledRevenueOptions: accounts.unbilled.options,
    initialDeferredRevenueMappingId: accounts.deferred.initialId,
    initialRecognizedRevenueMappingId: accounts.recognized.initialId,
    initialUnbilledRevenueMappingId: accounts.unbilled.initialId
  }
}
